<template>
	<div class="wrapper wrapper-content h100pp" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="float-e-margins ibox-content animated fadeInRight h100pp">
			<div class="row h100pp">
				<div class="form-horizontal h100pp">
					<div class="col-sm-3 gray_right02 h100pp mt50px">
						<div class="col-sm-6 text-left">
							<button class="btn btn-primary" @click="addNewVersion">新增</button>
						</div>
						<div class="col-sm-6 text-left">
							<button class="btn btn-primary" @click="deleteBtn">删除</button>
						</div>
						<div class="col-sm-12">
							<div class="col-sm-offset-1 w200px text-center mt30px">
								<button class="btn col-sm-10 h40px btn-primary js-select" v-for="(item,index) in versionArr" @click="selectBtn($event,index)" @mouseover="mouseOver">{{item.udcName}}</button>
							</div>
						</div>
					</div>
					<div class="col-sm-1 gray_left02 h100pp">
						
					</div>
					<div class="col-sm-8 h100pp mt50px">
						<div class="col-sm-6">
							<label class="col-sm-4 control-label">版本名称</label>
							<div class="col-sm-6">
								<input type="text"  class="form-control menuInput"  v-model="editVersion.udcName"/>
							</div>
						</div>
						<div class="col-sm-6">
							<label class="col-sm-4 control-label">版本号</label>
							<div class="col-sm-6">
								<input type="text" :disabled="this.type=='editVersionType'" class="form-control menuInput"  v-model="editVersion.licId"/>
							</div>
						</div>
						<div class="col-sm-12 h100pp mt30px">
							<div class="col-sm-6 h100pp">
								<div class="col-sm-12">
									<div id="ibox-content" class="col-sm-offset-2 col-sm-10" style="overflow: auto;">
										<ul id="jurisdictionTree" class="ztree" style="height:600px; width:350px;"></ul>
									</div>
								</div>
								<div class="col-sm-12 col-sm-offset-2">
									<div class="col-sm-offset-3">
										<button class="btn btn-primary btn-lg" @click="confirmBtn">保存</button>
									</div>
								</div>
							</div>
							<div class="col-sm-6 gray_left02 h100pp">
								<div class="col-sm-12" style="height:600px;">
									<label class="col-sm-4 control-label">备注</label>
									<textarea name="" rows="10" cols="35" v-model="editVersion.udcText"></textarea>
									<div class="col-sm-12  mt30px"  v-if="type=='editVersionType'">
										<div class="col-sm-12 text-left mt30px">
											<div class="col-sm-4"></div>
											<input type="checkbox"  v-model="isUser"/>
											<label>将本次变更的功能反映到操作员</label>
										</div>
										<div class="col-sm-12 text-left">
											<div class="col-sm-4"></div>
											<input type="checkbox" v-model="isCustomer" />
											<label>将本次变更的功能反映到下级所有组织机构</label>
										</div>
									</div>
								</div>
								<div class="col-sm-12 col-sm-offset-2">
									<div class="col-sm-offset-3">
										<button class="btn btn-primary btn-lg">取消</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<sub-modal ref="modalMsg" size="small" title="提示">
				{{messageStr}}
				<div slot="footer">
					<button class="btn btn-primary" @click="closeSub('modalMsg')">确定</button>
				</div>
		</sub-modal>
		<sub-modal ref="deleteMsg" size="small" title="提示">
				{{messageStr}}
				<div slot="footer">
					<button class="btn btn-primary mr10px" @click="closeSub('deleteMsg')">取消</button>
					<button class="btn btn-primary" @click="removeVersion()">确定</button>
				</div>
		</sub-modal>
	</div>
</template>

<script>
	import SubModal from 'components/common/SubModal'
	import { OPERATE_EXCEPTION } from 'static/message'
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	export default{
		name:"PageVersioning",
		components:{
			SubModal
		},
		data(){
			return{
				versionArr:[],
				loadingstatus:false,
				messageStr:'',
				groupList:[],
				setting:{
					check: {
						enable: true,
						chkboxType:{ "Y" : "ps", "N" : "ps" },
					},
					data: {
						simpleData: {
							enable: true,
							pIdKey: "parentId",
						},
						key:{
							url:"url_x",
						}
					},
				},
				editVersion:{
					udcName:'',
					licId:'',
					udcText:'',
				},
				queryParams:{
					types:'',
				},
				type:'addVersion',
				isCustomer:false,
				isUser:false,
				lastIndex:'',
			}
		},
		beforeMount(){
			this.getversionArr();
			this.getNewTree();
		},
		methods:{
			openSub(ref){
				this.$refs[ref].open();
			},
			closeSub(ref){
				this.$refs[ref].close();
			},
			selectBtn(e,index){
				this.type='editVersionType'
				$(e.target).removeClass('btn-primary').addClass('btn-success').siblings().removeClass('btn-success').addClass('btn-primary');
				$(e.target).unbind('mouseout',this.mouseOut);
				this.lastIndex=index;
				this.getJurisdictionTree();
				this.editVersion.udcName=this.versionArr[index].udcName;
				this.editVersion.licId=this.versionArr[index].udcCode;
				this.editVersion.udcText=this.versionArr[index].udcText;
			},
			mouseOver(e){
				if(e.target.classList.contains('btn-success'))return false;
				e.target.classList.add('btn-success');
				e.target.classList.remove('btn-primary');
				$(e.target).bind('mouseout',this.mouseOut);
			},
			mouseOut(e){
				e.target.classList.add('btn-primary');
				e.target.classList.remove('btn-success');
				$(e.target).unbind('mouseout',this.mouseOut);
			},
			//置空编辑单元
			addNewVersion(){
				$('.btn-success').removeClass('btn-success').addClass('btn-primary');
				this.editVersion.udcName='';
				this.editVersion.licId='';
				this.editVersion.udcText='';
				this.getNewTree()
			},
			//初始化树
			initTree(){
				$.fn.zTree.init($("#jurisdictionTree"), this.setting, this.groupList);
			},
			confirmBtn(){
				if(this.type=='editVersionType'){
					this.saveEditVersion();
				}else if(this.type=='addVersionType'){
					this.addVersion();
				}
			},
			deleteBtn(){
				if(this.lastIndex === ''){
					this.messageStr='请选择要删除的平台';
					this.openSub('modalMsg');
					return false
				}
				this.messageStr='是否确定删除该平台';
				this.$refs.deleteMsg.open();
				return false;
			},
			//获取版本列表
			getversionArr:function(){
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT+'/system/udcs/types/SYSTEM_TYPE')
				.then((res)=>{
					if(res.body.success){
						this.versionArr=res.body.data;
						this.addNewVersion();
					}else{
						this.messageStr=res.body.message;
						this.openSub('modalMsg');
					}
					this.loadingstatus = false;
				},(res)=>{
					this.loadingstatus = false;
					this.messageStr=res.body.message;
					this.openSub('modalMsg');
				}).catch((res)=>{
					this.loadingstatus = false;
					this.messageStr=OPERATE_EXCEPTION;
					this.openSub('modalMsg');
				})
			},
			//删除版本
			removeVersion(){
				this.$refs.deleteMsg.close();
				this.loadingstatus=true;
				this.$http.delete(process.env.API_ROOT+'/system/licence/'+this.versionArr[this.lastIndex].udcCode)
				.then((res)=>{
					if(res.body.success){
						this.messageStr='删除成功';
						this.openSub('modalMsg');
						this.getversionArr();
						this.type='addVersionType';
						//this.initTree();
					}else{
						this.messageStr=res.body.message;
						this.openSub('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.loadingstatus=false;
					this.messageStr=res.body.message;
					this.openSub('modalMsg');
				}).catch(res=>{
					this.loadingstatus=false;
					this.messageStr=OPERATE_EXCEPTION;
					this.openSub('modalMsg');
				})
			},
			//获取选中版本信息
			getJurisdictionTree(){
				this.loadingstatus=true;
				this.$http.get(process.env.API_ROOT+'/system/licence/'+this.versionArr[this.lastIndex].udcCode)
				.then((res)=>{
					if(res.body.success){
						this.groupList=res.body.data.resources;
						this.groupList.map(item=>{
							if(item.showType==0){
								item.checked=false;
							}else if(item.showType==1){
								item.checked=true;
							}
							this.setIcon(item);
						})
						this.initTree();
						this.editVersion.udcText=res.body.data.udcText;
						//this.initTree();
					}else{
						this.messageStr=res.body.message;
						this.openSub('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.loadingstatus=false;
					this.messageStr=res.body.message;
					this.openSub('modalMsg');
				}).catch(res=>{
					this.loadingstatus=false;
					this.messageStr=OPERATE_EXCEPTION;
					this.openSub('modalMsg');
				})
			},
			//获取所有可选资源
			getNewTree(){
				this.loadingstatus=true;
				this.type='addVersionType';
				this.queryParams.types='1,2,3,4'
				this.$http.get(process.env.API_ROOT+"/system/menu",{params:this.queryParams})
				.then((res)=>{
					if(res.body.success){
						this.groupList=res.body.data;
						this.groupList.map(item=>{
							item.icon=null;
							item.id=item.menuId
							if(item.checkOn==0){
								item.checked=false;
							}else if(item.checkOn==1){
								item.checked=true;
							}
							this.setIcon(item);
						})
						this.initTree();
						//this.initTree();
					}else{
						this.messageStr=res.body.message;
						this.openSub('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.loadingstatus=false;
					this.messageStr=res.body.message;
					this.openSub('modalMsg');
				}).catch(res=>{
					this.loadingstatus=false;
					this.messageStr=OPERATE_EXCEPTION;
					this.openSub('modalMsg');
				})
			},
			//保存编辑单元
			saveEditVersion(){
				let para={
					id:this.versionArr[this.lastIndex].id,
					licId:this.editVersion.licId,
					udcName:this.editVersion.udcName,
					udcText:this.editVersion.udcText,
					resourceIds:$.fn.zTree.getZTreeObj('jurisdictionTree').getCheckedNodes('true').map(item=>{
						return item.id
					}),
					isCustomer:this.isCustomer==true?1:0,
					isUser:this.isUser==true?1:0,
				};
				this.loadingstatus=true;
				this.$http.put(process.env.API_ROOT+'/system/licence/'+this.versionArr[this.lastIndex].udcCode,para)
				.then((res)=>{
					if(res.body.success){
						this.messageStr=res.body.data;
						this.openSub('modalMsg');
						this.getversionArr();
						//this.initTree();
					}else{
						this.messageStr=res.body.message;
						this.openSub('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.loadingstatus=false;
					this.messageStr=res.body.message;
					this.openSub('modalMsg');
				}).catch(res=>{
					this.loadingstatus=false;
					this.messageStr=OPERATE_EXCEPTION;
					this.openSub('modalMsg');
				})
			},
			setIcon(item){
				if(item.type == 3){
//					item.icon='../../../assets/project/images/map_icon_8a.png'
					item.icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjYjJkYmI4Mi0wYTFiLTlkNDItYjZlYy04MmUyYTZhNWJjNTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUJDOUJFQkU4RUI5MTFFNzg5RTBEQzc4NTMxM0RGRkYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUJDOUJFQkQ4RUI5MTFFNzg5RTBEQzc4NTMxM0RGRkYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3NjI5NmIxYy02ZDUwLTJlNGMtOWUyNy0zMDAwNGIyZWYyZmMiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDoxMDQwNjU2Mi0wZDUxLTExZTctYTVjOC1mOGI4OGNmY2FmZjciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5sgI7FAAAA9klEQVR42mL8//8/AzUBEwOVAQu5Goub54Mcsw2IXYC4tbc2sZ4oA4EapwGpKBy+44Wyq4C4nlgXcgHxCiCegSbODBVXAeKtpHr5BdBLF7C43hBq4GWKwxAEgJZ8AVIX6BPLUOenAvE+oM1riIzpECDlBMSzgXrOg8QYYQkbKPkcSEkAMUgAFLN/oPrcgPgTEJ/A4pgskBnQMJakecL2wuZloMsXAKkHQLEGLF7eA/XBbJgYI6G8jM/AwZ2Xoa7ngSVsoA/+kmKgBFCzARbHrANiWSDeCMQBxBr4DVo4ROApHLyJjhQCxdcGaOqAF1+Mg77EBggwAErJV/iOklBDAAAAAElFTkSuQmCC'
				}else if(item.type == 4){
					item.icon='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjYjJkYmI4Mi0wYTFiLTlkNDItYjZlYy04MmUyYTZhNWJjNTUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUJDOUJFQzI4RUI5MTFFNzg5RTBEQzc4NTMxM0RGRkYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUJDOUJFQzE4RUI5MTFFNzg5RTBEQzc4NTMxM0RGRkYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3NjI5NmIxYy02ZDUwLTJlNGMtOWUyNy0zMDAwNGIyZWYyZmMiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDoxMDQwNjU2Mi0wZDUxLTExZTctYTVjOC1mOGI4OGNmY2FmZjciLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz47dIIxAAABGElEQVR42mL8//8/AzUBEwOVAQu6QHHzfGYg9QCIZaBCD3prExWJNZAR5mWgQQFQMW4gXgLEhkDMC8SHgDiQkEFASzegu3ACcjAAFVwAWiKAJocPbEBxIZKXeYDUZyCeCMTsQJwBNJyR7EgBav4CpOqBGOQ6TiCuIyVSGElJNkDXmwIpaSj3MdDyswRjGY9hHEDqOBA/gfpMHBokOGN5AQEz2YA4EhSe0Mh6D8QLkYIqgSYJm+gwhHr5C7KXga5iJzvrATX/AFKWQFwAxHlAbEW0C4GuASUVJSj3LtCwZrLTITRhNwLxByD+DsRNZIUh0KAHSJbIosXmQyKCRAE9HRYgFw5AwwyghQOyHOmxTLXia9CW2AABBgCQJWw4XGEH6gAAAABJRU5ErkJggg=='
				}
			},
			//添加版本处理函数
			addVersion(){
				this.loadingstatus=true;
				let para={
					licId:this.editVersion.licId.replace(/\b(0+)/gi,""),
					udcName:this.editVersion.udcName,
					udcText:this.editVersion.udcText,
					resourceIds:$.fn.zTree.getZTreeObj('jurisdictionTree').getCheckedNodes('true').map(item=>{
						return item.id
					}),
				}
				this.$http.post(process.env.API_ROOT+'/system/licence/',para)
				.then((res)=>{
					if(res.body.success){
						this.messageStr=res.body.data;
						this.openSub('modalMsg');
						this.getversionArr();
						//this.initTree();
					}else{
						this.messageStr=res.body.message;
						this.openSub('modalMsg');
					}
					this.loadingstatus=false;
				},(res)=>{
					this.loadingstatus=false;
					this.messageStr=res.body.message;
					this.openSub('modalMsg');
				}).catch(res=>{
					this.loadingstatus=false;
					this.messageStr=OPERATE_EXCEPTION;
					this.openSub('modalMsg');
				})
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageVersioning.vue?272d03b2